module.exports = "/_next/static/images/7effab630214735592b685b19286a2c7.png";